import React from 'react';
import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

const CRMWaitlist = loadable(() => import('@/pages/CRM/Screener/LeadWaitlist')); // prettier-ignore

export enum CRMWaitlistRoutes {
  CRMWaitlist = '/crm/waitlist'
}

export const getCrmWaitlistRoutes = (): RouteObject[] => {
  return [
    {
      path: CRMWaitlistRoutes.CRMWaitlist,
      element: <CRMWaitlist />
    }
  ];
};
